// vendor
import { defineComponent, computed, PropType } from "@vue/composition-api";
// local
import * as NodeComponents from "../vue/node-types";
import { NodeData } from "./NodeData";

export const RunNode = defineComponent({

	emits:[ "next", "previous" ],
	props:{
		showPrevious:{
			type:Boolean,
			default:false
		},
		nodeId:{
			type:String,
			required:true
		},
		node:{
			type:Object as PropType<NodeData<any>>,
			required:true
		},
		isLast:{
			type:Boolean,
			default:false
		},
	},
	setup(props, context){

		const component = computed(() => {
			const c = (NodeComponents as any)[props.node.type];
			return c ? c : NodeComponents.Fallback;
		});

		const onEnd = async() => {
			context.emit("next");
		};

		const onPrevious = () => {
			context.emit("previous");
		};

		return {
			component,
			onEnd,
			onPrevious
		};
	}
});